import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { said,landingUrl,basename } from '../../AppConfig';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
import Button from 'grommet/components/Button';
import CloseIcon from 'grommet/components/icons/base/Close';
import { redirectPage,deleteUserData } from '../../State/actions/sessions';
import {logOutAttribute} from '../../AppConfig';
import CheckBox from 'grommet/components/CheckBox';
import {fetchSettings,updateSettings} from '../../State/actions/sessions';
import Layer from 'grommet/components/Layer';
import WarningIcon from 'grommet/components/icons/base/Alert';
import Spinning from 'grommet/components/icons/Spinning';
const SSO='SSO';
const PASSPORT='HPE Passport';


class UserDetailsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userDetails: '',

        };
        this.closePopUps = this.closePopUps.bind(this);
        this.deleteUser = this.deleteUser.bind(this)     
    }
    closePopUps(e) {
        this.props.click();
    }
    deleteUser()
    {
        var input ={
               "emailId": this.props.auth.userData.email,
               "uniqueId": this.props.auth.userData.uniqueId,
               "userId": this.props.auth.userData.hpclname
           }   
           this.setState({ showDeleteWarning: false });
           this.props.ondeleteUserData(input); 
    }

    renderConfirmationBox() {
        //let redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https%3A%2F%2F'+redirection_Link+'%2F' + basename.replace('/', '');
        if (this.state.showLogoutWarning !== true) {
            return undefined;
        }
        let message = 'Logout action will close the existing session. If want to save your changes click cancel button. Click Ok to Logout';
        return (
            <Layer closer={false} overlayClose={true} >
                <Box margin="none" pad="none" size='medium' >
                    <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
                        <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                            <WarningIcon colorIndex='warning' size='small' />
                            <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Logout Confirmation</Heading>
                        </Box>
                    </Box>
                    <Box direction="row" margin="small" pad={{ between: 'small' }} >
                        <Paragraph margin="small" >{message}</Paragraph>
                    </Box>
                    <Box direction='row'>
                        <Box margin='small'>
                            <Button label='Ok'
                                id='logOutYes'
                                onClick={() => {
                                    if(this.props.auth.ssoUser){
                                        localStorage.setItem(logOutAttribute,"true");
                                        window.location.reload();                                        
                                     }else{
                                        this.props.onLogOut();
                                    }
                                    
                                    //window.location.href = redirectUrl;
                                }}
                            />
                        </Box>
                        <Box margin='small'>
                            <Button size='small' label='Cancel' onClick={() => {
                                this.setState({ showLogoutWarning: false });
                            }} />
                        </Box>
                    </Box>
                </Box>
            </Layer >);
    }

    renderunSubscribeWarning(){
        if (this.state.showDeleteWarning !== true) {
            return undefined;
        }
          let message = 'All your data will be lost from the Sizers Database.  Would you like to continue?';
        return (
            <Layer closer={false} overlayClose={true} >
                <Box margin="none" pad="none" size='medium' >
                    <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
                        <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                            <WarningIcon colorIndex='warning' size='small' />
                            <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Delete Confirmation</Heading>
                        </Box>
                    </Box>
                    <Box direction="row" margin="small" pad={{ between: 'small' }} >
                        <Paragraph margin="small" >{message}</Paragraph>
                    </Box>
                    <Box direction='row'>
                        <Box margin='small'>
                            <Button label='Ok'
                                id='logOutYes'
                                onClick={() => {  
                                     this.deleteUser();  
                                     if(this.props.auth.ssoUser){
                                        localStorage.setItem(logOutAttribute,"true");
                                        window.location.reload();                                        
                                     }else{  
                                     this.props.onLogOut();  
                                     }                  
                                }}
                            />
                        </Box>
                        <Box margin='small'>
                            <Button size='small' label='Cancel' onClick={() => {
                                this.setState({ showDeleteWarning: false });
                            }} />
                        </Box>
                    </Box>
                </Box>
            </Layer >);
    }
    getUserType=()=>{
        return this.props.auth.ssoUser ? SSO : PASSPORT;
    }
    componentDidMount(){
               
        let queryString='?userId='+this.props.userDetails.email+'&authChannel='+this.getUserType();        
        this.props.onFetchPreferences(queryString);
    }    
    onPrefenceChanged = () => {
        let inputs={
            userId:this.props.userDetails.email,
            authChannel:this.getUserType(),
            EmailNotification:!this.props.auth.userSettings.emailNotification,
        }
        this.props.onUpdatePreference(inputs);
    }

    render() {        
        let content = '';
        if (this.props.userDetails !== undefined && this.props.userDetails !== null) {



            this.state.userDetails = this.props.userDetails;
            content = "";
            content = <Box margin="none" pad="none" direction="column" className="UserDetailsContent" style={{ width: '25%', height: 'auto' }}>
                <Box margin="none" pad="none" >
                    <Box margin="none" pad="none" align="center" className="triangle-up" style={{ margin: 'auto 88%' }}></Box>
                </Box>
                <Box margin="none" pad="none" style={{ backgroundColor: '#fff', borderBottom: '3px solid #01a982' }} className="ListItemAlign1">
                    <Box direction="row" margin="none" pad="small" separator="bottom" style={{ backgroundColor: 'rgb(66, 85, 99)', color: 'white' }}>
                        <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
                            <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>{'User Details'}</Heading>
                        </Box>
                        <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
                            <CloseIcon size='small' className="CloseIconStyle" style={{ stroke: '#fff' }} />
                        </Box>
                    </Box>
                    <Box style={{ padding: '10px' }}>
                        <Box>
                            <Heading tag='h3' padding='none' margin='none' style={{ fontSize: '20px' }}>
                                {this.props.userDetails.username + ' ' + this.props.userDetails.lastName}
                            </Heading>
                            <Heading tag='h5' padding='none'>
                                {this.props.userDetails.email}
                            </Heading>
                        </Box>
                        <Box style={{display:'flex', flexDirection:'row'}}>
                            <CheckBox label='Email Notification' disabled={this.props.auth.userSettings.isLoading} toggle={true} reverse={true} checked={this.props.auth.userSettings.emailNotification} onChange={this.onPrefenceChanged}/>
                            {this.props.auth.userSettings.isLoading?<Spinning style={{marginLeft:'30px'}}/>:null}
                        </Box>
                    </Box>                                           
                    <Box  direction="row"margin='none'  style={{display:'flex',justifyContent:'flex-end',marginTop:'20px'}}>
                        <Button className="Userdetailsbox" label='Logout' plain={true}  onClick={() => {
                            this.setState({ showLogoutWarning: true });
                        }} />
                        <Button className="Userdetailsbox" pad='none' margin='none'  label="Unsubscribe here" plain={true} onClick={() => {
                            this.setState({ showDeleteWarning: true });
                        }} />
                    </Box >
                   {/* <Box margin='none' pad='none'>
                         { <Button pad='none' margin='none' style={{fontStyle:'16px'}} label="Unsubscribe here" plain={true} onClick={() => {
                            this.setState({ showDeleteWarning: true });
                        }} />}
                    </Box>   */}                 
                </Box>
            </Box>

        } else {
            content = '';
        }
        let warning = this.renderConfirmationBox();
        let unSubscribeWarning  = this.renderunSubscribeWarning();
        return (
            <Box margin="none" pad="none">
                {content}
                {warning}
                {unSubscribeWarning}
            </Box>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        activeSession: state.sessions.activeSession,
        DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers,
        WhatsNewContent: state.sessions.sessionDefaults.whatsNew,
        auth:state.auth
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onRedirectPage: (isTrue, path) => {
            dispatch(redirectPage(isTrue, path));
        },
        ondeleteUserData: (inputs) => {
            dispatch(deleteUserData(inputs));
        },
        onFetchPreferences:(inputs)=>{
            dispatch(fetchSettings(inputs));
        },
        onUpdatePreference:(inputs)=>{
            dispatch(updateSettings(inputs))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsComponent);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/UserDetails.js